
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { SiteVacancyRequestType } from "./vacancy.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

@Component
export default class SiteVacancyForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    name: string | null = null;
    offers: string | null = null;
    requirement: string | null = null;
    responsibilities: string | null = null;
    salon_id: number | null = null;
    salary: number | null = null;
    currency_id: number | null = null;
    phone: string | null = null;
    work_schedule: string | null = null;

    getFormData(): SiteVacancyRequestType {
       return{
            name: this.name,
            offers: this.offers,
            requirement: this.requirement,
            responsibilities: this.responsibilities,
            salon_id: this.salon_id,
            salary: this.salary,
            currency_id: this.currency_id,
            phone: this.phone,
            work_schedule: this.work_schedule
       } 
    }

    setFormData(): void {}
}
